import * as types from "../actionTypes";

export function setQuiz(payload) {
  return { type: types.SET_QUIZ, payload };
}

export function syncQuizConfig(payload) {
  return { type: types.SYNC_QUIZ_SUCCESS, payload };
}

export function nextPage(payload) {
  return { type: types.QUIZ_NEXT_PAGE, payload };
}

export function prevPage(payload) {
  return { type: types.QUIZ_PREV_PAGE, payload };
}

export function setProgress(payload) {
  return { type: types.SET_PROGRESS, payload };
}

export function updateProgress(payload) {
  return { type: types.UPDATE_PROGRESS, payload };
}

export function loadQuiz(payload) {
  return { type: types.LOAD_QUIZ, payload };
}

export function resultsSubmittedSuccess(payload) {
  return { type: types.RESULTS_SUBMITTED_SUCCESS, payload };
}

export function resultsSubmittedFailed(payload) {
  return { type: types.RESULTS_SUBMITTED_FAILED, payload };
}

export function resetQuizData(payload) {
  return { type: types.RESET_QUIZ_DATA, payload };
}

export function resetStore(payload) {
  return { type: types.RESET_STORE, payload };
}

export function setPrizes(payload) {
  return { type: types.SET_PRIZES, payload };
}
